import React from "react";
import { Trash2 } from "lucide-react";
import { AlertRule } from "../../types";

interface DeleteConfirmModalProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  alertRule: AlertRule;
  bulkRules?: AlertRule[];
}

const DeleteConfirmModal: React.FC<DeleteConfirmModalProps> = ({
  isOpen,
  onConfirm,
  onCancel,
  alertRule,
  bulkRules,
}) => {
  if (!isOpen) return null;

  const isMultipleRules = bulkRules && bulkRules.length > 1;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-md mx-4">
        <div className="flex items-center mb-4">
          <div className="flex-shrink-0 h-10 w-10">
            <div className="h-10 w-10 rounded-full bg-red-100 flex items-center justify-center">
              <Trash2 className="w-5 h-5 text-red-600" />
            </div>
          </div>
          <div className="ml-3">
            <h3 className="text-lg font-medium text-gray-900">
              Delete Alert {isMultipleRules ? "Rules" : "Rule"}
            </h3>
          </div>
        </div>

        <div className="mb-6">
          <p className="text-sm text-gray-600">
            {isMultipleRules ? (
              <>
                Are you sure you want to delete{" "}
                <strong>{bulkRules.length} alert rules</strong>? This action
                cannot be undone.
              </>
            ) : (
              <>
                Are you sure you want to delete the alert rule{" "}
                <strong>"{alertRule.name}"</strong>? This action cannot be
                undone.
              </>
            )}
          </p>
        </div>

        <div className="flex justify-end space-x-3">
          <button
            type="button"
            onClick={onCancel}
            className="px-4 py-2 text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors"
          >
            Delete {isMultipleRules ? "Rules" : "Rule"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmModal;
